import React from "react";
import { Gannt } from "../../components/gannt";
import { Footer } from "../../footer/footer";

export function Naptar_Page() {
    return (
        <div>
            <Gannt />
            <Footer />
        </div>
    );
}